import React, { useState } from 'react';
import { Modal, Box, TextField, Button, Typography, CircularProgress } from '@mui/material';
import { useAdmin } from '../context/AdminContextNew';

const AdminLoginModal = ({ open, onClose }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const { login, loginLoading, loginError } = useAdmin();

  const handleLogin = async () => {
    if (!username.trim() || !password.trim()) {
      return;
    }

    const loginData = {
      username: username.trim(),
      password: password.trim()
    };

    await login(loginData);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="admin-login-modal"
      aria-describedby="admin-authentication"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: '#0F1722',
          border: '1px solid #2C495C',
          borderRadius: '16px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          p: 4,
          backdropFilter: 'blur(10px)',
          background: 'linear-gradient(135deg, rgba(15, 23, 34, 0.9), rgba(33, 50, 73, 0.9))',
        }}
      >
        <Typography variant="h5" component="h2" sx={{ mb: 3, color: '#fff', textAlign: 'center' }}>
          Admin Girişi
        </Typography>
        
        <TextField
          label="Kullanıcı Adı"
          variant="outlined"
          fullWidth
          margin="normal"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          sx={{
            mb: 2,
            '& .MuiOutlinedInput-root': {
              color: '#fff',
              '& fieldset': {
                borderColor: '#2C495C',
              },
              '&:hover fieldset': {
                borderColor: '#1475E1',
              },
            },
            '& .MuiInputLabel-root': {
              color: '#8EAABE',
            },
          }}
        />
        
        <TextField
          label="Şifre"
          type="password"
          variant="outlined"
          fullWidth
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          sx={{
            mb: 3,
            '& .MuiOutlinedInput-root': {
              color: '#fff',
              '& fieldset': {
                borderColor: '#2C495C',
              },
              '&:hover fieldset': {
                borderColor: '#1475E1',
              },
            },
            '& .MuiInputLabel-root': {
              color: '#8EAABE',
            },
          }}
        />
        
        {loginError && (
          <Typography variant="body2" sx={{ color: '#ff5252', mb: 2, textAlign: 'center' }}>
            {loginError}
          </Typography>
        )}
        
        <Button
          variant="contained"
          fullWidth
          onClick={handleLogin}
          disabled={loginLoading || !username.trim() || !password.trim()}
          sx={{
            py: 1.5,
            background: 'linear-gradient(90deg, #1475E1, #5AABFF)',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            textTransform: 'none',
            '&:hover': {
              background: 'linear-gradient(90deg, #0C63C9, #4A9AEE)',
              boxShadow: '0 4px 15px rgba(20, 117, 225, 0.4)',
            },
            '&:disabled': {
              background: '#2C495C',
              color: '#8EAABE',
            },
          }}
        >
          {loginLoading ? (
            <CircularProgress size={24} sx={{ color: '#fff' }} />
          ) : (
            'Giriş Yap'
          )}
        </Button>
      </Box>
    </Modal>
  );
};

export default AdminLoginModal; 